import React, {useEffect, useState} from "react";
import OrderFilterModal from "../../income/OrderFilterModal";
import OrderCategoryButton from "../../income/OrderCategoryButton";
import {Row} from "antd";

export default (props) => {
    const [visible, setVisible] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)
    const [value, setValue] = useState(null)

    useEffect(() => {
        setDefaultValue(props.defaultValue)
    }, [props])

    return (
        <Row>
            <OrderCategoryButton {...props} />
            <OrderFilterModal {...props}/>
        </Row>
    )
}